<template>
  <div class="profile-box-container w-100">
    <div class="mb-3">
      <label for="" class="profile-box-title">{{ $t("profile_Info") }}</label>
    </div>

    <!-- Skeleton State -->
    <template v-if="!profile || !profile.first_name">
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("name") }}</div>
        <v-skeleton-loader type="text" width="120" height="20" />
      </div>
      <v-divider></v-divider>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("date_of_birth") }}</div>
        <v-skeleton-loader type="text" width="100" height="20" />
      </div>
    </template>

    <!-- Loaded State -->
    <template v-else>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("name") }}</div>
        <div class="profile-box-second-text">
          {{ profile.first_name + " " + profile.last_name }}
        </div>
      </div>
      <v-divider></v-divider>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("date_of_birth") }}</div>
        <div class="profile-box-second-text">{{ profile.date_of_birth }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "BasicInfo",
  props: ["profile"],
};
</script>
